module.exports = __webpack_public_path__ + "static/media/card-webcol.64ef42c1.png";